module.exports = __webpack_public_path__ + "media/images/front/programs/icon-play-6fcba8cfe00f016c7aa30e4edbdaf075.svg";